import Cookies from 'js-cookie';

const CART_COOKIE_NAME = 'cartId';
const COOKIE_EXPIRES_DAYS = 7;

export const useCartCookie = () => {
  const getCartId = () => {
    return Cookies.get(CART_COOKIE_NAME);
  };

  const setCartId = (cartId) => {
    Cookies.set(CART_COOKIE_NAME, cartId, {
      expires: COOKIE_EXPIRES_DAYS,
      sameSite: 'strict'
    });
  };

  const removeCartId = () => {
    Cookies.remove(CART_COOKIE_NAME);
  };

  return {
    getCartId,
    setCartId,
    removeCartId
  };
};
